import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

import { ScreenType } from "../../utils/breakpoints";

import VPTAutoPlaySlider from "./Components/VPTAutoPlaySlider";
import VPTWideScreenLayout from "./Components/VPTWideScreenLayoutV2";
import "./style.css";
import { connect } from "react-redux";
import { useEffect } from "react";

function VirtualPT(props) {
    const navigate = useNavigate();
    const { location } = props.Utils;

    useEffect(() => {
        if (location == null) {
            navigate("/");
        }
    }, [location]);

    const screenSize = ScreenType(useMediaQuery);

    return <div id="virtual-pt">{screenSize == "xl" ? <VPTWideScreenLayout /> : <VPTAutoPlaySlider />}</div>;
}

const mapStateToProps = (state) => ({
    Utils: state.Utils,
});

export default connect(mapStateToProps, {})(VirtualPT);
